import type { IPlatformAuth } from "../platform.type";

export const auth: IPlatformAuth = {
  async getAccessToken() {
    try {
      return await Office.auth.getAccessToken({
        allowSignInPrompt: true,
        allowConsentPrompt: true,
        forMSGraphAccess: false,
      });
    } catch (error: any) {
      console.error(`Authorization error: ${error.message}, code: ${error.code}`);
      throw new Error("Failed to authorize your Outlook account.");
    }
  }
};